import { useEffect } from "react";

import { Link } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import PDFImage from '../assets/file-pdf-regular.svg';

const Privacy = () => {
    useEffect(() => {
        window.scrollTo(0,0)
        window.location.href = "https://www.quilter.com/important-information/privacy-notices/appointed-representative-privacy-notice/"
      },[])

    return (
        <div>
            <Header />
            <div className="bg-white">
                <div className="container mx-auto px-4 pt-20 pb-14">
                    <section>
                        <h1 className="text-4xl font-black text-bexley-blue-dark mb-10">Privacy Policy</h1>
                    </section>
                    <section className="flex flex-col md:flex-row">
                        <div className="flex-1 leading-relaxed">
                            <div className="controls mt-6 mb-8 xl:mb-6 flex flex-col lg:flex-row text-center">
                                <p className="mt-6 text-2xl font-light">You are being redirected to the privacy policy. If this is not automatic, please click here:</p>
                                <div className="controls mt-6 mb-8 xl:mb-6 flex flex-col lg:block text-center">
                                    <a href="https://www.quilter.com/important-information/privacy-notices/appointed-representative-privacy-notice/" className="flex-1 bg-bexley-green-light rounded-full text-bexley-blue-dark py-2 px-8 inline-block font-black mb-2 lg:mb-0 lg:mr-4">Privacy policy</a>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Privacy